<app-relatorio-container
    tituloRelatorio="Controle Administrativo"
    categoriaRelatorio="Cadastro"
    [filtrosTemplate]="filtrosTemplate"
    [pdfBlob]="(job$ | async)?.pdfBlob"
    [pdfFileName]="(job$ | async)?.fileName ?? 'controle-administrativo.pdf'"
    [statusPreview]="(job$ | async)?.status ?? null"
    [progressoPreview]="(job$ | async)?.progress ?? 0"
>
    <ng-template #filtrosTemplate>
        <div class="flex flex-col gap-6" [formGroup]="form">
            <div class="field">
                <label class="font-semibold block mb-2">UF</label>
                <app-estado-select [uf]="ufSelecionada" (ufChange)="alterarUf($event)" [removeBR]="true" (touched)="marcarUfTocada()"></app-estado-select>
                @if (!ufSelecionada && ufTocada) {
                    <small class="p-error mt-2" style="color: red">Selecione uma UF.</small>
                }
            </div>

            <div class="field">
                <label for="mes" class="font-semibold block mb-2">Mês</label>
                <p-select id="mes" [options]="opcoesMeses" formControlName="mes" optionLabel="label" optionValue="value" [appendTo]="'body'" placeholder="Selecione o mês" [showClear]="true" class="h-[30px] w-full"></p-select>
                @if (form.get('mes')?.invalid && form.get('mes')?.touched) {
                    <small class="p-error mt-2" style="color: red">Selecione o mês.</small>
                }
            </div>

            <div class="field">
                <label for="ano" class="font-semibold block mb-2">Ano</label>
                <p-inputnumber inputId="ano" formControlName="ano" [min]="2000" [useGrouping]="false" placeholder="Informe o ano" fluid></p-inputnumber>
                @if (form.get('ano')?.invalid && form.get('ano')?.touched) {
                    <small class="p-error mt-2" style="color: red">Informe um ano válido (mínimo 2000).</small>
                }
            </div>

            <div class="field pt-5 flex justify-end gap-2">
                <p-button label="Limpar" icon="pi pi-eraser" [variant]="'text'" (click)="limparFormulario()"></p-button>
                <p-button label="Gerar Relatório" icon="pi pi-search" [appCan]="roleGerar" (click)="gerarRelatorio()" [loading]="isPending" [disabled]="isPending || form.invalid || !ufSelecionada"></p-button>
            </div>
        </div>
    </ng-template>
</app-relatorio-container>
